<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 150"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>outdoor-enthusiasts</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-324.000000, -33.000000)">
        <g
          id="outdoor-enthusiasts"
          transform="translate(325.000000, 33.000000)">
          <path
            id="Path"
            d="M170.818193,81.8181818 C170.815052,48.4048854 150.49458,18.3508104 119.487669,5.90011177 C88.480759,-6.55058691 53.0184679,1.10414626 29.9081796,25.2363439 C6.79789129,49.3685415 0.683780904,85.1286685 14.4636364,115.568182 L163.536364,115.568182 C168.34154,104.965823 170.824307,93.4586158 170.818193,81.8181818 Z"
            class="fill-extra-light"
            fill-rule="nonzero" />
          <line
            id="Path"
            x1="9.22727273"
            y1="115.629545"
            x2="168.772727"
            y2="115.629545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="0.0227272727"
            y1="115.629545"
            x2="5.13636364"
            y2="115.629545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="172.863636"
            y1="115.629545"
            x2="177.977273"
            y2="115.629545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M145.945455,74.4954545 C131.014093,79.1059114 114.997515,78.804794 100.25,73.6363636 L100.25,115.568182 L168.772727,115.568182 C157.461364,103.418182 150.609091,90.2863636 148.625,76.1113636 C148.530504,75.515476 148.177754,74.9917027 147.661097,74.6801309 C147.14444,74.3685591 146.516584,74.300975 145.945455,74.4954545 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M145.945455,74.4954545 C131.014093,79.1059114 114.997515,78.804794 100.25,73.6363636 L100.25,115.568182 L168.772727,115.568182 C157.461364,103.418182 150.609091,90.2863636 148.625,76.1113636 C148.530504,75.515476 148.177754,74.9917027 147.661097,74.6801309 C147.14444,74.3685591 146.516584,74.300975 145.945455,74.4954545 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M120.704545,115.629545 L80.8181818,115.629545 C89,105.688636 94.8090909,89.5295455 99.2272727,74.4136364 C99.2272727,73.8487997 99.6851633,73.3909091 100.25,73.3909091 C100.814837,73.3909091 101.272727,73.8487997 101.272727,74.4136364 C105.220455,88.5477273 111.643182,104.318182 120.704545,115.629545 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M100.25,115.629545 L90.0227273,115.629545 C97.2227273,109.493182 99.4522727,91.3704545 100.25,73.6568182 L100.25,115.629545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M112.522727,85.9090909 C117.270631,89.2778966 123.111717,90.7381681 128.886364,90"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M144.227273,86.9931818 C144.227273,86.9931818 142.181818,95.175 129.909091,96.1977273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M122.75,115.629545 L120.704545,115.629545 L119.906818,108.409091 C119.841981,107.888647 120.004754,107.365525 120.353434,106.973749 C120.702114,106.581974 121.202821,106.359613 121.727273,106.363583 L121.727273,106.363583 C122.251725,106.359613 122.752431,106.581974 123.101112,106.973749 C123.449792,107.365525 123.612564,107.888647 123.547727,108.409091 L122.75,115.629545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M168.772727,115.629545 L166.727273,115.629545 L165.929545,108.409091 C165.864708,107.888647 166.027481,107.365525 166.376161,106.973749 C166.724841,106.581974 167.225548,106.359613 167.75,106.363583 L167.75,106.363583 C168.274452,106.359613 168.775159,106.581974 169.123839,106.973749 C169.472519,107.365525 169.635292,107.888647 169.570455,108.409091 L168.772727,115.629545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M126.840909,36.8181818 C126.338375,36.8216207 125.840187,36.9115714 125.368182,37.0840909 C124.850542,33.7796357 122.003844,31.3441554 118.659091,31.3441554 C115.314337,31.3441554 112.46764,33.7796357 111.95,37.0840909 C111.477995,36.9115714 110.979806,36.8216207 110.477273,36.8181818 C108.217926,36.8181818 106.386364,38.6497442 106.386364,40.9090909 C106.386364,43.1684376 108.217926,45 110.477273,45 L126.840909,45 C129.100256,45 130.931818,43.1684376 130.931818,40.9090909 C130.931818,38.6497442 129.100256,36.8181818 126.840909,36.8181818 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M126.840909,36.8181818 C126.338375,36.8216207 125.840187,36.9115714 125.368182,37.0840909 C124.850542,33.7796357 122.003844,31.3441554 118.659091,31.3441554 C115.314337,31.3441554 112.46764,33.7796357 111.95,37.0840909 C111.477995,36.9115714 110.979806,36.8216207 110.477273,36.8181818 C108.217926,36.8181818 106.386364,38.6497442 106.386364,40.9090909 C106.386364,43.1684376 108.217926,45 110.477273,45 L126.840909,45 C129.100256,45 130.931818,43.1684376 130.931818,40.9090909 C130.931818,38.6497442 129.100256,36.8181818 126.840909,36.8181818 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M71.5727273,84.6818182 L79.7545455,84.6818182 L79.7545455,79.9772727 C79.7545455,66.9860292 69.2230617,56.4545455 56.2318182,56.4545455 C43.2405746,56.4545455 32.7090909,66.9860292 32.7090909,79.9772727 L32.7090909,84.6818182 L40.8909091,84.6818182 L40.8909091,99.9818182 L71.5727273,99.9818182 L71.5727273,84.6818182 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M71.5727273,84.6818182 L79.7545455,84.6818182 L79.7545455,79.9772727 C79.7545455,66.9860292 69.2230617,56.4545455 56.2318182,56.4545455 C43.2405746,56.4545455 32.7090909,66.9860292 32.7090909,79.9772727 L32.7090909,84.6818182 L40.8909091,84.6818182 L40.8909091,99.9818182 L71.5727273,99.9818182 L71.5727273,84.6818182 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="40.9727273"
            y1="75.2727273"
            x2="40.9727273"
            y2="84.6818182"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="71.5727273"
            y1="84.6818182"
            x2="71.5727273"
            y2="75.2727273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M56.2727273,68.2159091 L49.175,57.5590909 C53.792247,56.0865015 58.7532075,56.0865015 63.3704545,57.5590909 L56.2727273,68.2159091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="42.1590909"
            y="124.670455"
            width="8.22272727"
            height="18.8181818" />
          <rect
            id="Rectangle"
            class="fill-white"
            fill-rule="nonzero"
            x="42.1590909"
            y="124.670455"
            width="8.22272727"
            height="18.8181818" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="42.1590909"
            y="124.670455"
            width="8.22272727"
            height="18.8181818" />
          <path
            id="Path"
            d="M52.4886364,114.218182 C52.5316386,113.064829 53.0958694,111.993351 54.0225226,111.305321 C54.9491757,110.617291 56.1380559,110.387103 57.2545455,110.679545 C58.9042135,111.158682 60.0436193,112.664028 60.0568182,114.381818 L60.3636364,122.4 C60.3520399,123.68347 61.3714586,124.739296 62.6545455,124.772727 L69.2204545,124.772727 C70.5195789,124.772727 71.5727273,123.719579 71.5727273,122.420455 L71.5727273,99.9818182 L40.8909091,99.9818182 L40.8909091,122.318182 C40.8619463,122.974032 41.1083768,123.612146 41.5706387,124.078293 C42.0329006,124.544439 42.6689302,124.796201 43.325,124.772727 L49.8909091,124.772727 C51.173996,124.739296 52.1934147,123.68347 52.1818182,122.4 L52.4886364,114.218182 Z"
            class="fill-light"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M72.7386618,37.6363636 C72.7444385,36.2406251 71.7566536,35.0381044 70.3863636,34.7727273 L70.3863636,32.9318182 C70.3863636,25.1370721 64.0674734,18.8181818 56.2727273,18.8181818 C48.4779811,18.8181818 42.1590909,25.1370721 42.1590909,32.9318182 L42.1590909,34.7727273 C40.743841,35.0409626 39.7435012,36.3122759 39.8156908,37.7509111 C39.8878804,39.1895462 41.0104618,40.3543331 42.4454545,40.4795455 C43.8291729,47.0118212 49.5955046,51.684634 56.2727273,51.684634 C62.9499499,51.684634 68.7162817,47.0118212 70.1,40.4795455 C71.5718366,40.3351557 72.704334,39.1148679 72.7386618,37.6363636 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M50.975,32.9318182 C50.251585,32.9235498 49.5951666,33.3540618 49.3144945,34.0208607 C49.0338225,34.6876597 49.1847679,35.458011 49.696333,35.9695761 C50.2078981,36.4811411 50.9782494,36.6320866 51.6450484,36.3514146 C52.3118473,36.0707425 52.7423593,35.4143241 52.7340909,34.6909091 C52.7230395,33.7240046 51.9419044,32.9428696 50.975,32.9318182 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M61.5704545,32.9318182 C60.8470395,32.9235498 60.1906212,33.3540618 59.9099491,34.0208607 C59.629277,34.6876597 59.7802225,35.458011 60.2917876,35.9695761 C60.8033526,36.4811411 61.5737039,36.6320866 62.2405029,36.3514146 C62.9073019,36.0707425 63.3378139,35.4143241 63.3295455,34.6909091 C63.3295455,33.71939 62.5419736,32.9318182 61.5704545,32.9318182 L61.5704545,32.9318182 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="48.6227273"
            cy="39.3954545"
            r="1.75909091" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="63.9227273"
            cy="39.3954545"
            r="1.75909091" />
          <path
            id="Path"
            d="M71.5727273,29.4136364 C71.5689872,25.2747659 69.8908198,21.3134929 66.9202222,18.4315123 C63.9496245,15.5495317 59.9393591,13.9920657 55.8022727,14.1136364 C47.3936057,14.6051354 40.8599242,21.6254634 40.9727273,30.0477273 L40.9727273,34.1386364 C43.105472,32.7123494 44.7647329,30.6827814 45.7386364,28.3090909 C46.5358666,26.3453775 48.5710688,25.1799919 50.6681818,25.4863636 C54.3841408,26.0385924 58.1613137,26.0385924 61.8772727,25.4863636 C63.9743857,25.1799919 66.009588,26.3453775 66.8068182,28.3090909 C67.7807217,30.6827814 69.4399825,32.7123494 71.5727273,34.1386364 L71.5727273,29.4136364 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M71.5727273,29.4136364 C71.5689872,25.2747659 69.8908198,21.3134929 66.9202222,18.4315123 C63.9496245,15.5495317 59.9393591,13.9920657 55.8022727,14.1136364 C47.3936057,14.6051354 40.8599242,21.6254634 40.9727273,30.0477273 L40.9727273,34.1386364 C43.105472,32.7123494 44.7647329,30.6827814 45.7386364,28.3090909 C46.5358666,26.3453775 48.5710688,25.1799919 50.6681818,25.4863636 C54.3841408,26.0385924 58.1613137,26.0385924 61.8772727,25.4863636 C63.9743857,25.1799919 66.009588,26.3453775 66.8068182,28.3090909 C67.7807217,30.6827814 69.4399825,32.7123494 71.5727273,34.1386364 L71.5727273,29.4136364 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <rect
            id="Rectangle"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="40.9727273"
            y="99.9818182"
            width="30.5795455"
            height="4.70454545" />
          <path
            id="Path"
            d="M52.7340909,43.6295455 C54.8820184,45.0411454 57.6634361,45.0411454 59.8113636,43.6295455"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="64.4954545"
            y1="78.8113636"
            x2="68.0340909"
            y2="78.8113636"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="45.6977273"
            y1="78.8113636"
            x2="49.2159091"
            y2="78.8113636"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <ellipse
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="56.2727273"
            cy="145.840909"
            rx="23.5227273"
            ry="3.53863636" />
          <path
            id="Path"
            d="M52.4886364,114.218182 C52.5316386,113.064829 53.0958694,111.993351 54.0225226,111.305321 C54.9491757,110.617291 56.1380559,110.387103 57.2545455,110.679545 C58.9042135,111.158682 60.0436193,112.664028 60.0568182,114.381818 L60.3636364,122.4 C60.3520399,123.68347 61.3714586,124.739296 62.6545455,124.772727 L69.2204545,124.772727 C70.5195789,124.772727 71.5727273,123.719579 71.5727273,122.420455 L71.5727273,99.9818182 L40.8909091,99.9818182 L40.8909091,122.318182 C40.8619463,122.974032 41.1083768,123.612146 41.5706387,124.078293 C42.0329006,124.544439 42.6689302,124.796201 43.325,124.772727 L49.8909091,124.772727 C51.173996,124.739296 52.1934147,123.68347 52.1818182,122.4 L52.4886364,114.218182 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="42.1590909"
            y="131.727273"
            width="8.22272727"
            height="11.7613636" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="62.1636364"
            y="124.670455"
            width="8.22272727"
            height="18.8181818" />
          <rect
            id="Rectangle"
            class="fill-white"
            fill-rule="nonzero"
            x="62.1636364"
            y="124.670455"
            width="8.22272727"
            height="18.8181818" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="62.1636364"
            y="124.670455"
            width="8.22272727"
            height="18.8181818" />
          <path
            id="Path"
            d="M40.9727273,106.363636 C40.9727273,108.622983 39.1411649,110.454545 36.8818182,110.454545 C34.6224715,110.454545 32.7909091,108.622983 32.7909091,106.363636 L32.7909091,84.6818182 L40.9727273,84.6818182 L40.9727273,106.363636 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M79.7954545,106.363636 C79.7954545,108.622983 77.9638922,110.454545 75.7045455,110.454545 C73.4451988,110.454545 71.6136364,108.622983 71.6136364,106.363636 L71.6136364,84.6818182 L79.7954545,84.6818182 L79.7954545,106.363636 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M58.625,70.5681818 C58.625,71.8673062 57.5718516,72.9204545 56.2727273,72.9204545 C54.9736029,72.9204545 53.9204545,71.8673062 53.9204545,70.5681818 L51.6909091,89.5909091 C51.6142706,90.2128748 51.791203,90.8395102 52.1818182,91.3295455 L54.4318182,94.0909091 C54.8823861,94.6450018 55.5585633,94.9666766 56.2727273,94.9666766 C56.9868913,94.9666766 57.6630685,94.6450018 58.1136364,94.0909091 L60.3636364,91.3295455 C60.7542516,90.8395102 60.9311839,90.2128748 60.8545455,89.5909091 L58.625,70.5681818 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="56.3545455"
            y1="72.7977273"
            x2="56.3545455"
            y2="95.0318182"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M63.3704545,57.5590909 L56.2727273,68.2159091 L49.175,57.5590909 C46.0029611,58.5704891 43.0817577,60.2437321 40.6045455,62.4681818 L56.2727273,72.9204545 L71.9409091,62.4681818 C69.4636968,60.2437321 66.5424935,58.5704891 63.3704545,57.5590909 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M76.2568182,75.2727273 C75.6096094,75.2838877 75.0908129,75.8117859 75.0909091,76.4590909 L75.0909091,78.8113636 C75.1018402,79.4506949 75.6174869,79.9663416 76.2568182,79.9772727 L79.7954563,79.9772727 C79.7960691,78.3973185 79.6384646,76.8212736 79.325,75.2727273 L76.2568182,75.2727273 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="62.1636364"
            y="131.727273"
            width="8.22272727"
            height="11.7613636" />
          <path
            id="Path"
            d="M37.4545455,75.4159091 C37.4348434,73.5130867 36.2610319,71.8130838 34.4886364,71.1204545 C33.3457747,73.9337036 32.755477,76.9407495 32.75,79.9772727 L32.75,80.1204545 C35.3482487,80.1204545 37.4545455,78.0141578 37.4545455,75.4159091 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M71.5727273,18.7568182 C71.5588687,16.7049028 70.205459,14.9031242 68.2386364,14.3181818 L56.9681818,10.8409091 C56.5155426,10.698099 56.0299119,10.698099 55.5772727,10.8409091 L44.3068182,14.3181818 C42.3255295,14.9074732 40.968543,16.7306637 40.9727176,18.7977273 L40.9727176,25.9159091 L71.6545455,25.9159091 L71.5727273,18.7568182 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M71.5727273,18.7568182 C71.5588687,16.7049028 70.205459,14.9031242 68.2386364,14.3181818 L56.9681818,10.8409091 C56.5155426,10.698099 56.0299119,10.698099 55.5772727,10.8409091 L44.3068182,14.3181818 C42.3255295,14.9074732 40.968543,16.7306637 40.9727176,18.7977273 L40.9727176,25.9159091 L71.6545455,25.9159091 L71.5727273,18.7568182 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M72.7386364,31.7659091 C61.9853896,28.6295455 50.5600649,28.6295455 39.8068182,31.7659091 L40.9727273,25.875 C45.8268187,24.4461959 50.8462783,23.6554591 55.9045455,23.5227273 C61.2013338,23.6909159 66.460059,24.4804112 71.5727273,25.875 L72.7386364,31.7659091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <circle
            id="Oval"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="56.2727273"
            cy="17.6522727"
            r="2.35227273" />
          <path
            id="Path"
            d="M49.7477273,143.488636 C50.5607452,143.482013 51.3116116,143.052392 51.7293053,142.354844 C52.146999,141.657295 52.1712033,140.792548 51.7931818,140.072727 C50.5603759,137.835088 48.211568,136.441462 45.6568182,136.431818 L44.4909091,136.431818 C41.9373627,136.445809 39.5905902,137.838228 38.3545455,140.072727 C37.9765239,140.792548 38.0007282,141.657295 38.418422,142.354844 C38.8361157,143.052392 39.5869821,143.482013 40.4,143.488636 L49.7477273,143.488636 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M72.1045455,143.488636 C72.912726,143.470659 73.6550582,143.038949 74.0703556,142.345402 C74.4856531,141.651855 74.5157285,140.793645 74.15,140.072727 C72.9139553,137.838228 70.5671828,136.445809 68.0136364,136.431818 L66.8272727,136.431818 C64.2737263,136.445809 61.9269538,137.838228 60.6909091,140.072727 C60.3251806,140.793645 60.355256,141.651855 60.7705535,142.345402 C61.1858509,143.038949 61.9281831,143.470659 62.7363636,143.488636 L72.1045455,143.488636 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <circle
            id="Oval"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="56.2727273"
            cy="70.5681818"
            r="2.35227273" />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
